<template>
  <li
      class="sidebar-link-group pl-4 pr-3 py-2 rounded-lg mb-0.5 last:mb-0"
      :class="activeCondition && 'sidebar-link-group--active'"
  >
    <slot :handleClick="handleClick" :expanded="expanded" />
  </li>
</template>

<script>
export default {
  name: 'SidebarLinkGroup',
  props: {
    activeCondition: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expanded: this.activeCondition
    }
  },
  watch: {
    activeCondition(val) {
      if (val) this.expanded = true
    }
  },
  methods: {
    handleClick() {
      this.expanded = !this.expanded
    }
  }
}
</script>

<style scoped>
/* Same primary-based rail as UserSidebar .us-sidebar-row-active (theme-aware) */
.sidebar-link-group--active {
  background-image: linear-gradient(
    to right,
    color-mix(in srgb, var(--v-primary-base) 18%, transparent),
    color-mix(in srgb, var(--v-primary-base) 5%, transparent)
  );
}

html.dark .sidebar-link-group--active {
  background-image: linear-gradient(
    to right,
    color-mix(in srgb, var(--v-primary-base) 24%, transparent),
    color-mix(in srgb, var(--v-primary-base) 4%, transparent)
  );
}
</style>
